import { render, staticRenderFns } from "./opc_accordion.vue?vue&type=template&id=f468e93a&"
import script from "./opc_accordion.vue?vue&type=script&lang=js&"
export * from "./opc_accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports